(()=>{
const STORE='https://04-studios.com';
const P=new URLSearchParams(location.search);
const KIOSK=P.get('kiosk')==='1';
if(KIOSK)document.body.classList.add('kiosk');
/* catalog + heroes come from the section's JSON (sections/kiosk-04.liquid) */
let KD={};try{KD=JSON.parse(document.getElementById('kiosk-data').textContent||'{}')}catch(e){KD={}}
const CAT=(Array.isArray(KD.products)?KD.products:[]).filter(p=>p&&p.v&&p.v.length&&p.img&&p.img.length);
window.CATALOG=CAT;

/* real Shopify AJAX cart on this domain, mirrored from local state; failures never block the kiosk */
const ROOT=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/').replace(/\/?$/,'/');
let cartQ=Promise.resolve();
function cartCall(path,body){
  const run=()=>fetch(ROOT+path,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body||{})})
    .then(r=>{if(!r.ok)throw new Error(path+' '+r.status);return r.json()})
    .catch(e=>{console.warn('[kiosk] cart',e);return null});
  cartQ=cartQ.then(run,run);return cartQ;
}
const cartAdd=(id,q)=>q>0?cartCall('cart/add.js',{items:[{id,quantity:q}]}):Promise.resolve(null);
const cartSet=(id,q)=>cartCall('cart/change.js',{id:String(id),quantity:Math.max(0,q)});
const cartClear=()=>cartCall('cart/clear.js',{});
const $=s=>document.querySelector(s);

/* ---------- i18n ---------- */
const T={
 it:{goBack:'Indietro',stMenu:'Menu',stOrder:'Ordine',stPay:'Pagamento',restart:'Ricomincia',attH:'Ordina da qui.',attP:"Questo schermo è il nostro menu. Sfogli i capi, vedi foto, materiali e pezzi rimasti, scegli la taglia e aggiungi all'ordine. Poi scegli tu: te lo spediamo a casa, lo ritiri qui più tardi o lo porti via subito. Paghi dal tuo telefono con un QR oppure direttamente su questo schermo.",attM1:'Spedito a casa',homeR:'Home',heroH:'Tutto quello che vedi, ordinabile da qui.',heroP:'Tocca + per scegliere la taglia.',allP:'Tutti i pezzi',attM2:'Ritiro allo stand',attM3:'Subito con te',addedBtn:'Aggiunto ✓',tap:'Tocca per iniziare',storyH:'Spieghiamo il capo. Non lo vendiamo.',who:'Ogni pezzo nasce da un luogo vero: un lago nelle Dolomiti, un bosco giapponese, una rotta migratoria. Lo stampiamo su cotone organico pesante e lo produciamo in lotti numerati. Quando un lotto finisce, finisce.',f1:'Peso felpe',f2:'Fibra',f2v:'Cotone organico',f3:'Produzione',f4:'Studio',howT:'Come funziona',h1:'Scegli dal menu',h1s:'Foto, materiali, taglie e pezzi rimasti, tutto sullo schermo.',h2:'Scegli come riceverlo',h2s:'Spedito a casa, ritirato qui più tardi, o portato via subito.',h3:'Paga dal tuo telefono',h3s:'Scansioni il QR: si apre il checkout [04] con il carrello pronto.',startOrder:"Inizia l'ordine",yourOrder:'Il tuo ordine',seeOrder:'Vedi ordine',back:'← Menu',idleH:'Sei ancora qui?',idleP:"Se non tocchi lo schermo, ricominciamo e svuotiamo l'ordine.",stay:'Continua',thH:'Grazie.',newOrder:'Nuovo ordine',
  cats:{tutto:'Tutto',felpe:'Felpe',maglie:'Maglie',tshirt:'T-shirt',capispalla:'Capispalla',oggetti:'Oggetti'},
  pcs:n=>n===1?'1 pezzo':n+' pezzi', left:n=>n===1?'Ultimo pezzo':'Ne restano '+n, sizeLeft:n=>n+' pz', soldSize:'Esaurita', soldOut:'Esaurito', made:'Su ordinazione', unique:'Pezzo unico 1/1',
  chooseSize:'Scegli la taglia', size:'Taglia', add:"Aggiungi all'ordine", addN:'Aggiungi', inOrder:'Già nel tuo ordine', pickSize:'Scegli una taglia', specs:'Materiali e costruzione', look:'Completa il look', fit:'Vestibilità', avail:'Disponibilità',
  outMsg:'Al momento esaurito. Chiedi allo staff per il prossimo lotto.', madeMsg:'Prodotto su ordinazione: si paga ora, si spedisce quando è pronto.',
  added:(t,s)=>'Aggiunto: '+t+(s?', '+s:''), orderH:'Il tuo ordine', remove:'Rimuovi', empty:'Il tuo ordine è vuoto.', toMenu:'Torna al menu', addMore:'Aggiungi altro',
  howGet:'Come vuoi riceverlo?', m_ship:'Spedizione a casa', m_shipS:"Lo ricevi all'indirizzo che inserisci al pagamento. Gratis sopra €200 in Italia.", m_pickup:'Ritiro più tardi', m_pickupS:'Paghi ora, lo ritiri allo stand o in studio a Trieste. Al checkout scegli "Ritiro".', m_stand:'Prendilo ora allo stand', m_standS:'Mostri il codice allo staff, paghi alla cassa e lo porti via subito.',
  note:'Nota (facoltativa)', notePh:'Es. regalo, nome sul biglietto, orario di ritiro', sub:'Subtotale', shipLater:'Spedizione e tasse calcolate al checkout', proceed:'Procedi al pagamento', chooseMode:'Scegli come riceverlo',
  payH:'Scansiona e paga dal tuo telefono', payP:'Si apre il checkout di 04-studios.com con il tuo carrello già pronto.', code:'Codice ordine', s1:'Inquadra il QR con la fotocamera', s2:'Controlla il carrello e inserisci i dati', s3:'Paga con Apple Pay, Google Pay, carta o PayPal', onScreen:'Oppure apri il checkout qui', done:'Ho pagato',
  standH:'Mostra questo codice allo staff', standP:'Lo staff prepara i pezzi e incassa alla cassa. Il QR contiene il tuo ordine.', standDone:'Fatto',
  thP:'Il tuo ordine è registrato. Lo schermo torna all’inizio tra poco.', thStand:'Lo staff ti chiama con il codice',
  whoH:'Sei già nostro cliente?', whoP:'Così prepariamo il checkout giusto per te.',
  w_member:'Sì, ho già un account', w_memberS:'Accedi al checkout con la tua email, i tuoi dati sono già salvati.',
  w_new:'No, voglio iscrivermi', w_newS:'Lasci la tua email: il tuo account nasce con questo ordine.',
  w_guest:'Continua come ospite', w_guestS:'Inserisci i dati solo per questo ordine.',
  whoTag:{member:'Cliente registrato',new:'Nuovo cliente',guest:'Ospite'},
  h_member:'Al checkout inserisci la tua email: ti arriva un codice per accedere, i tuoi dati sono già salvati.',
  h_new:'La tua email è già nel checkout. Il tuo account si crea con il primo ordine.',
  h_guest:'Al checkout inserisci email e indirizzo solo per questo ordine.',
  emailL:'La tua email', nl:'Voglio ricevere i drop e le novità [04] via email', accNote:'Il tuo account si crea con il primo ordine.', cont:'Continua', emailErr:'Controlla l’email: sembra incompleta.',
  payH2:'Paga il tuo ordine', payPhone:'Paga dal telefono', payHere:'Paga su questo schermo', change:'Cambia',
 },
 en:{goBack:'Back',stMenu:'Menu',stOrder:'Order',stPay:'Payment',restart:'Start over',attH:'Order from here.',attP:'This screen is our menu. Browse the pieces, see photos, materials and pieces left, pick your size and add it to your order. Then you choose: we ship it to your home, you pick it up here later or you take it with you right now. Pay on your phone with a QR or directly on this screen.',attM1:'Shipped home',homeR:'Home',heroH:'Everything you see, orderable from here.',heroP:'Tap + to choose your size.',allP:'All pieces',attM2:'Pick up at the stand',attM3:'Take it now',addedBtn:'Added ✓',tap:'Tap to start',storyH:'We explain the piece. We do not sell it.',who:'Every piece starts from a real place: a lake in the Dolomites, a Japanese forest, a migration route. We print it on heavy organic cotton and make it in numbered batches. When a batch ends, it ends.',f1:'Hoodie weight',f2:'Fibre',f2v:'Organic cotton',f3:'Made in',f4:'Studio',howT:'How it works',h1:'Pick from the menu',h1s:'Photos, materials, sizes and pieces left, all on screen.',h2:'Choose how to receive it',h2s:'Shipped home, picked up here later, or taken right now.',h3:'Pay on your phone',h3s:'Scan the QR: the [04] checkout opens with your cart ready.',startOrder:'Start your order',yourOrder:'Your order',seeOrder:'View order',back:'← Menu',idleH:'Still there?',idleP:'If nobody touches the screen, we start over and clear the order.',stay:'Continue',thH:'Thank you.',newOrder:'New order',
  cats:{tutto:'All',felpe:'Hoodies',maglie:'Knits',tshirt:'T-shirts',capispalla:'Outerwear',oggetti:'Objects'},
  pcs:n=>n===1?'1 piece':n+' pieces', left:n=>n===1?'Last piece':n+' left', sizeLeft:n=>n+' left', soldSize:'Sold out', soldOut:'Sold out', made:'Made to order', unique:'One of one 1/1',
  chooseSize:'Choose your size', size:'Size', add:'Add to order', addN:'Add', inOrder:'Already in your order', pickSize:'Choose a size', specs:'Materials and construction', look:'Complete the look', fit:'Fit', avail:'Availability',
  outMsg:'Sold out for now. Ask the staff about the next batch.', madeMsg:'Made to order: pay now, ships when ready.',
  added:(t,s)=>'Added: '+t+(s?', '+s:''), orderH:'Your order', remove:'Remove', empty:'Your order is empty.', toMenu:'Back to menu', addMore:'Add more',
  howGet:'How do you want to receive it?', m_ship:'Ship to my home', m_shipS:'Delivered to the address you enter at checkout. Free over €200 in Italy.', m_pickup:'Pick up later', m_pickupS:'Pay now, collect at the stand or our Trieste studio. Choose "Pickup" at checkout.', m_stand:'Take it now at the stand', m_standS:'Show the code to the staff, pay at the till and take it with you.',
  note:'Note (optional)', notePh:'E.g. gift, name on the card, pickup time', sub:'Subtotal', shipLater:'Shipping and taxes calculated at checkout', proceed:'Go to payment', chooseMode:'Choose how to receive it',
  payH:'Scan and pay on your phone', payP:'The 04-studios.com checkout opens with your cart ready.', code:'Order code', s1:'Point your camera at the QR', s2:'Check the cart and add your details', s3:'Pay with Apple Pay, Google Pay, card or PayPal', onScreen:'Or open checkout here', done:'I have paid',
  standH:'Show this code to the staff', standP:'The staff prepares your pieces and takes payment at the till. The QR holds your order.', standDone:'Done',
  thP:'Your order is in. This screen returns to the start shortly.', thStand:'The staff will call your code',
  whoH:'Are you already a customer?', whoP:'So we can set up the right checkout for you.',
  w_member:'Yes, I have an account', w_memberS:'Sign in at checkout with your email, your details are already saved.',
  w_new:'No, I want to join', w_newS:'Leave your email: your account starts with this order.',
  w_guest:'Continue as guest', w_guestS:'Enter your details just for this order.',
  whoTag:{member:'Registered customer',new:'New customer',guest:'Guest'},
  h_member:'At checkout enter your email: you get a code to sign in, your details are already saved.',
  h_new:'Your email is already in the checkout. Your account is created with your first order.',
  h_guest:'At checkout enter your email and address just for this order.',
  emailL:'Your email', nl:'I want to get [04] drops and news by email', accNote:'Your account is created with your first order.', cont:'Continue', emailErr:'Check your email: it looks incomplete.',
  payH2:'Pay for your order', payPhone:'Pay on your phone', payHere:'Pay on this screen', change:'Change',
 }
};
let lang='it';
const t=k=>T[lang][k];

/* ---------- helpers ---------- */
const eur=n=>n.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g,'.')+' €';
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const total=p=>p.v.reduce((a,v)=>a+Math.max(0,v.q),0);
const status=p=>{
  if(p.v.length===1&&p.v[0].q===1&&p.v[0].a&&/1\/1|A\*G\*/i.test(p.t+p.col))return'unique';
  if(!p.v.some(v=>v.a))return'out';
  if(p.v.some(v=>v.a)&&total(p)<=0)return'made';
  return'in';
};
const maxFor=v=>v.q>0?v.q:(v.a?5:0);
const minPrice=p=>Math.min(...p.v.map(v=>v.p));
const byH=h=>CAT.find(p=>p.h===h);

/* spec parsing: "Label: value" from bullets, else sentences */
function specs(p){
  let d=p.d.replace(/ARCHITECTURAL SPECS:?/i,'').replace(/ARTIFACT STATUS:?/i,'');
  let parts;
  if(d.includes('•'))parts=d.split('•');
  else parts=d.replace(/([a-z\)])([A-Z])/g,'$1. $2').split(/(?<=\.)\s+|\n+/);
  return parts.map(s=>s.trim().replace(/\.$/,'')).filter(s=>s.length>2).slice(0,12).map(s=>{
    const m=s.match(/^([^:]{3,32}):\s*(.+)$/);return m?{k:m[1],v:m[2]}:{v:s};
  });
}
function originOf(p){
  const d=p.d.toUpperCase();
  const gsm=(d.match(/(\d{3,4})\s*G(SM|MS)/)||[])[1];
  const where=d.includes('BARCELOS')?'Barcelos, PT':d.includes('FLORENCE')?'Firenze, IT':d.includes('TRIESTE')?'Trieste, IT':d.includes('CHINA')?'Cina':d.includes('PORTUGAL')?'Portogallo':'';
  const fibre=d.includes('ORGANIC COTTON')?(lang==='it'?'Cotone organico':'Organic cotton'):d.includes('RECYCLED POLYESTER')?(lang==='it'?'Poliestere riciclato':'Recycled polyester'):d.includes('LAMBSKIN')||d.includes('LEATHER')?(lang==='it'?'Pelle':'Leather'):d.includes('PAPER')?(lang==='it'?'Carta':'Paper'):'';
  return [gsm&&['Peso',gsm+' GSM'],fibre&&[lang==='it'?'Materiale':'Material',fibre],where&&[lang==='it'?'Prodotto a':'Made in',where]].filter(Boolean);
}

/* ---------- state ---------- */
const S={screen:'attract',cart:new Map(),mode:null,note:'',code:'',product:null,size:null,qty:1,who:null,whoOk:false,email:'',nl:false};
function lines(){return [...S.cart.entries()].map(([id,l])=>({id,...l}))}
function count(){return lines().reduce((a,l)=>a+l.qty,0)}
function sum(){return lines().reduce((a,l)=>a+l.qty*l.price,0)}

/* ---------- screens ---------- */
const BACK={story:'attract',menu:'story',order:'menu',pay:'order',thanks:null};
function show(name){
  S.screen=name;
  document.querySelectorAll('.screen').forEach(s=>s.hidden=s.id!=='s-'+name);
  const inFlow=['menu','order','pay'].includes(name);
  $('#steps').hidden=!inFlow;
  document.querySelectorAll('#steps span').forEach(s=>s.classList.toggle('on',['menu','order','pay'].indexOf(s.dataset.st)<=['menu','order','pay'].indexOf(name)));
  $('#restartBtn').hidden=name==='attract';
  $('#backBtn').hidden=!BACK[name];
  $('#langs').style.marginLeft=inFlow?'0':'auto';
  $('#orderbar').hidden=!(name==='menu');
  $('#app').classList.toggle('cartside',name==='menu');
  $('#app').classList.toggle('onhero',name==='attract');
  if(name==='attract')startSlides();else stopSlides();
  if(name==='order')renderOrder();
  if(name==='pay')renderPay();
  if(name==='thanks')thanks();
  setBg({attract:'off',menu:'page',story:'panel',order:'panel',pay:'panel',thanks:'full'}[name]||'off');
  const sc=$('#s-'+name);if(sc)sc.scrollTop=0;
}
function applyLang(){
  document.documentElement.lang=lang;
  document.querySelectorAll('[data-i18n]').forEach(el=>{const v=t(el.dataset.i18n);if(typeof v==='string')el.textContent=v});
  document.querySelectorAll('#langs button').forEach(b=>b.classList.toggle('on',b.dataset.l===lang));
  renderMenu();updateBar();
  if(S.screen==='order')renderOrder();
  if(S.screen==='pay')renderPay();
  if($('#sheet').classList.contains('open'))renderSheet();
}

/* attract slideshow */
let slideT=null,slideI=0;
const heroW=u=>u+(u.includes('?')?'&':'?')+'width=1800';
const HEROES=(Array.isArray(KD.heroes)&&KD.heroes.length?KD.heroes:[]).map(heroW);
/* MG_0405 (the white waffle crewneck portrait) is always the first slide */
$('#slides').innerHTML=HEROES.map((u,i)=>`<img src="${u}" alt="" ${i?'loading="lazy"':''} class="${i?'':'on'}">`).join('');
function startSlides(){stopSlides();const im=[...document.querySelectorAll('#slides img')];im.forEach((x,i)=>x.classList.toggle('on',i===0));slideI=0;slideT=setInterval(()=>{im[slideI].classList.remove('on');slideI=(slideI+1)%im.length;im[slideI].classList.add('on')},6000)}
function stopSlides(){clearInterval(slideT)}


/* moss as protagonist: one Layer per host, animated from current k to target k */
const MOSS=new Map();let mossLUT=null;
const reducedMotion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
/* background moss modes, in the theme's spirit: creeps up from the bottom and fades out
   around 35-40% of the height; 'panel' adds a light top creep (topStrength .35) */
const BG_PROFILE={
  page:t=>E_().ss(.6,1,t),
  panel:t=>Math.max(E_().ss(.6,1,t),.35*(1-E_().ss(0,.22,t))),
  full:t=>.2+.8*E_().ss(.05,1,t)
};
const E_=()=>window.Moss04Engine;
function mossCfg(host){
  const E=window.Moss04Engine;
  if(host.id==='bgMoss'){const md=host.dataset.mode||'page';return{key:'bg-'+md,o:{size:1.2,dir:'up',anchor:'bottom',profile:BG_PROFILE[md]||BG_PROFILE.page}}}
  const side=host.id==='obMoss'&&$('#app').classList.contains('cartside')&&innerWidth>=1024;
  if(host.id==='obMoss'&&!side)return{key:'bar',o:{size:1.1,dir:'up',anchor:'bottom',profile:t=>.15+.85*E.ss(.05,1,t)}};
  return{key:'top',o:{size:1,dir:'up',anchor:'top',profile:t=>.45+.55*E.ss(0,1,t)}};
}
function mossTo(host,k,dur=1200){
  const E=window.Moss04Engine;if(typeof host==='string')host=$(host);if(!E||!host)return;
  let m=MOSS.get(host);
  if(!m){
    m={k:0,target:0,seed:1+Math.floor(Math.random()*9999),L:null,key:'',w:0,h:0,raf:0};MOSS.set(host,m);
    if(window.ResizeObserver){let tm;new ResizeObserver(()=>{clearTimeout(tm);tm=setTimeout(()=>{
      if(host.clientWidth!==m.w||host.clientHeight!==m.h||m.k!==m.target||(m.L&&mossCfg(host).key!==m.key))mossTo(host,m.target,500)},150)}).observe(host)}
  }
  m.target=k;cancelAnimationFrame(m.raf);
  const W=host.clientWidth,H=host.clientHeight;
  if(!W||!H)return; /* hidden or collapsed: the observer applies the target when it gets a size */
  const c=mossCfg(host);
  if(!m.L||m.key!==c.key){if(m.L)m.L.cv.remove();mossLUT=mossLUT||E.makeLUT(E.DEF);m.L=new E.Layer(host,{lut:mossLUT,...c.o});m.key=c.key;m.w=0}
  const edge=x=>x<=0?0:.25+1.05*x; /* more moss reaches higher */
  if(m.w!==W||m.h!==H){E.setSeed(m.seed);m.L.build();m.w=W;m.h=H;m.L.paint(m.k,edge(m.k))}
  const from=m.k;
  if(reducedMotion()||!dur||from===k){m.k=k;m.L.paint(k,edge(k));return}
  const t0=performance.now();
  const step=now=>{const p=Math.min(1,(now-t0)/dur),e=p*p*(3-2*p);m.k=from+(k-from)*e;m.L.paint(m.k,edge(m.k));if(p<1)m.raf=requestAnimationFrame(step)};
  m.raf=requestAnimationFrame(step);
}
let bgMode='';
function setBg(mode){
  const h=$('#bgMoss');h.classList.toggle('off',mode==='off');
  if(mode==='off'||mode===bgMode){bgMode=mode;return}
  bgMode=mode;h.dataset.mode=mode;mossTo(h,0,0);mossTo(h,1,reducedMotion()?0:mode==='full'?3200:2000);
}

/* ---------- menu ---------- */
const CATS=['felpe','maglie','tshirt','capispalla','oggetti'];
const coverOf=p=>p.cover||p.img[0];
/* site-style grid cell: moss-floor cover, white + top-right, name and price on the photo */
function cell(p,small){
  const st=status(p),tot=total(p),out=st==='out';
  let tag='';
  if(out)tag=`<span class="cell-tag">${t('soldOut')}</span>`;
  else if(st==='unique')tag=`<span class="cell-tag moss">${t('unique')}</span>`;
  else if(st==='made')tag=`<span class="cell-tag">${t('made')}</span>`;
  else if(tot<=3)tag=`<span class="cell-tag">${t('left')(tot)}</span>`;
  return `<div class="cell ${out?'out':''} ${small?'small':''}"><button class="cell-open" data-open="${p.h}" aria-label="${esc(p.t)}"><img src="${esc(coverOf(p))}" data-fb="${esc(p.img[0])}" onerror="if(this.dataset.fb&&this.src!==this.dataset.fb){this.src=this.dataset.fb}" alt="" loading="lazy"></button>${tag}
    <div class="cell-meta num"><span>${esc(p.t)}</span><span>${eur(minPrice(p))}</span></div>
    ${out||small?'':`<button class="cell-plus" data-plus="${p.h}" aria-label="${esc(p.t)}: ${t('chooseSize')}"><i aria-hidden="true">+</i></button>`}</div>`;
}
const STRIP=['felpe','maglie','tshirt','oggetti'];
function catCover(c){const ps=CAT.filter(p=>p.c===c&&status(p)!=='out');const p=ps.find(x=>x.coverKnown)||ps[0]||CAT.find(x=>x.c===c);return p}
function renderMenu(){
  const sorted=c=>CAT.filter(p=>p.c===c).sort((a,b)=>(status(a)==='out')-(status(b)==='out'));
  const all=CAT.filter(p=>status(p)!=='out').concat(CAT.filter(p=>status(p)==='out'));
  $('#rail').innerHTML=`<button data-c="home" class="on">${t('homeR')}</button>`+CATS.map(c=>`<button data-c="${c}">${t('cats')[c]}<sup class="num">${CAT.filter(p=>p.c===c).length}</sup></button>`).join('');
  $('#menuScroll').innerHTML=`<section id="cat-home" data-c="home" class="home">
    <div class="home-hero"><img src="${esc(HEROES[1]||HEROES[0]||'')}" alt="">
      <div class="hh-copy"><span class="lbl">${esc(KD.event||'FIELD CAMP')} · [04]-STUDIOS</span><h2>${t('heroH')}</h2><p>${t('heroP')}</p></div></div>
    <div class="cat-strip">${STRIP.map(c=>{const p=catCover(c);return p?`<button class="cs-tile" data-jump="${c}"><img src="${esc(coverOf(p))}" data-fb="${esc(p.img[0])}" onerror="if(this.dataset.fb&&this.src!==this.dataset.fb){this.src=this.dataset.fb}" alt="" loading="lazy"><span>${t('cats')[c]} &rarr;</span></button>`:''}).join('')}</div>
    <div class="cat-h"><h3>${t('allP')}</h3><span class="lbl num">${all.length}</span></div>
    <div class="cells">${all.map(p=>cell(p)).join('')}</div>
  </section>`+CATS.map(c=>`<section id="cat-${c}" data-c="${c}"><div class="cat-h"><h3>${t('cats')[c]}</h3><span class="lbl num">${CAT.filter(p=>p.c===c).length}</span></div><div class="cells">${sorted(c).map(p=>cell(p)).join('')}</div></section>`).join('');
}
$('#rail').addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;const sec=$('#cat-'+b.dataset.c);$('#menuScroll').scrollTo({top:b.dataset.c==='home'?0:sec.offsetTop-8,behavior:'smooth'});});
$('#menuScroll').addEventListener('scroll',()=>{
  const sc=$('#menuScroll');let cur='home';
  CATS.forEach(c=>{const s=$('#cat-'+c);if(s.offsetTop-40<=sc.scrollTop)cur=c});
  document.querySelectorAll('#rail button').forEach(b=>b.classList.toggle('on',b.dataset.c===cur));
},{passive:true});
document.addEventListener('click',e=>{
  const pl=e.target.closest('[data-plus]');if(pl){openProduct(pl.dataset.plus,true);return}
  const op=e.target.closest('[data-open]');if(op){openProduct(op.dataset.open);return}
  const jp=e.target.closest('[data-jump]');if(jp){const sec=$('#cat-'+jp.dataset.jump);if(sec)$('#menuScroll').scrollTo({top:sec.offsetTop-8,behavior:'smooth'})}});

/* ---------- product sheet ---------- */
function openProduct(h,jump){
  const p=byH(h);S.product=p;S.qty=1;
  const avail=p.v.filter(v=>v.a);
  S.size=p.v.length===1?(p.v[0].a?p.v[0].id:null):null;
  renderSheet();
  $('#sheet').classList.add('open');
  $('#shBody').scrollTop=0;
  if(jump)setTimeout(jumpToSize,420); /* after the sheet slide-in */
}
/* "+" from the grid: bring the size picker into view and pulse it; single variant: pulse the add button */
function jumpToSize(){
  const sz=document.querySelector('#shBody .sizes'),body=$('#shBody');
  let el=sz?sz.parentElement:null;
  if(el&&document.querySelectorAll('#shBody .size').length>1){
    const r=el.getBoundingClientRect(),br=body.getBoundingClientRect();
    body.scrollTo({top:body.scrollTop+r.top-br.top-Math.max(16,(br.height-r.height)/2),behavior:reducedMotion()?'auto':'smooth'});
  }else{el=$('#addBtn');if(el&&!el.disabled)el.focus({preventScroll:true})}
  if(!el)return;el.classList.remove('pulse');void el.offsetWidth;el.classList.add('pulse');setTimeout(()=>el.classList.remove('pulse'),2100);
}
function closeSheet(){$('#sheet').classList.remove('open')}
$('#shBack').onclick=closeSheet;
function renderSheet(){
  const p=S.product;if(!p)return;
  const st=status(p),tot=total(p);
  $('#pdCol').textContent=p.col;
  const sp=specs(p),org=originOf(p);
  const mates=CAT.filter(x=>x.h!==p.h&&status(x)!=='out'&&(x.col===p.col||x.c!==p.c)).sort((a,b)=>(b.col===p.col)-(a.col===p.col)).slice(0,3);
  const hasSizes=p.v.length>1||(p.v[0].s&&p.v[0].s!=='');
  let stock='';
  if(st==='out')stock=`<p class="stock-note low"><i></i>${t('outMsg')}</p>`;
  else if(st==='made')stock=`<p class="stock-note"><i></i>${t('madeMsg')}</p>`;
  else if(st==='unique')stock=`<p class="stock-note"><i></i>${t('unique')}. ${lang==='it'?'Non verrà rifatto.':'It will not be made again.'}</p>`;
  else stock=`<p class="stock-note ${tot<=3?'low':''}"><i></i>${t('avail')}: <span class="num">${tot}</span> ${lang==='it'?'pezzi in totale':'pieces in total'}</p>`;
  $('#shBody').innerHTML=`<div class="pd">
    <div class="gal-wrap"><div class="gal">
      <div class="gal-track" id="galTrack">${p.img.map((u,i)=>`<img src="${u.replace('width=900','width=1200')}" alt="${esc(p.t)} ${i+1}" loading="${i<2?'eager':'lazy'}">`).join('')}</div>
      ${p.img.length>1?`<button class="gal-nav l" data-g="-1" aria-label="Precedente">←</button><button class="gal-nav r" data-g="1" aria-label="Successiva">→</button><div class="dots" id="dots">${p.img.map((_,i)=>`<i class="${i?'':'on'}"></i>`).join('')}</div>`:''}
    </div>
    ${p.img.length>1?`<div class="thumbs">${p.img.map((u,i)=>`<button data-ti="${i}" class="${i?'':'on'}" aria-label="Foto ${i+1}"><img src="${u.replace('width=900','width=160')}" alt="" loading="eager"></button>`).join('')}</div>`:''}
    </div>
    <div class="info">
      <div style="display:grid;gap:8px"><h2 id="pdTitle">${esc(p.t)}</h2><div class="price num">${eur(S.size?p.v.find(v=>v.id===S.size).p:minPrice(p))}</div></div>
      ${p.seo?`<p class="lead">${esc(p.seo)}</p>`:''}
      ${org.length?`<div class="origin">${org.map(([k,v])=>`<div><span class="lbl" style="color:var(--mute)">${k}</span><b>${v}</b></div>`).join('')}</div>`:''}
      ${hasSizes?`<div style="display:grid;gap:10px"><div style="display:flex;justify-content:space-between;align-items:baseline"><span class="lbl">${t('chooseSize')}</span>${p.fit?`<span class="hint">${esc(p.fit)}</span>`:''}</div>
      <div class="sizes">${p.v.map(v=>`<button class="size ${S.size===v.id?'on':''}" data-v="${v.id}" ${v.a?'':'disabled'}><b>${esc(v.s||'Unica')}</b><small class="num">${v.a?(v.q>0?t('sizeLeft')(v.q):t('made')):t('soldSize')}</small></button>`).join('')}</div></div>`:''}
      ${stock}
      <details class="specs" open><summary class="lbl">${t('specs')}</summary><ul>${sp.map(s=>s.k?`<li><span>${esc(s.k)}</span><span>${esc(s.v)}</span></li>`:`<li class="solo"><span style="font-size:14px;text-transform:none;letter-spacing:0;color:var(--ink)">${esc(s.v)}</span></li>`).join('')}</ul></details>
      ${mates.length?`<div class="look"><h4>${t('look')}</h4><div class="cells">${mates.map(m=>cell(m,true)).join('')}</div></div>`:''}
    </div></div>`;
  renderFoot();
  const tr=$('#galTrack');
  if(tr){tr.addEventListener('scroll',()=>{const i=Math.round(tr.scrollLeft/tr.clientWidth);document.querySelectorAll('#dots i').forEach((d,j)=>d.classList.toggle('on',i===j));document.querySelectorAll('.thumbs button').forEach((d,j)=>d.classList.toggle('on',i===j))},{passive:true})}
}
function renderFoot(){
  const p=S.product,st=status(p);
  const v=p.v.find(x=>x.id===S.size);
  const inCart=v&&S.cart.has(v.id)?S.cart.get(v.id).qty:0;
  const mx=v?maxFor(v)-inCart:0;
  if(S.qty>Math.max(1,mx))S.qty=Math.max(1,mx);
  let label=t('add'),dis=false;
  if(st==='out'){label=t('soldOut');dis=true}
  else if(!v){label=t('pickSize');dis=true}
  else if(mx<=0){label=t('inOrder');dis=true}
  const showQty=st!=='unique'&&st!=='out';
  $('#shFoot').innerHTML=`${showQty?`<div class="qty"><button id="qm" ${S.qty<=1?'disabled':''} aria-label="Meno">−</button><span class="num">${S.qty}</span><button id="qp" ${!v||S.qty>=mx?'disabled':''} aria-label="Più">+</button></div>`:''}
    <button class="btn moss" id="addBtn" ${dis?'disabled':''}>${label}${v&&!dis?` · <span class="num">${eur(v.p*S.qty)}</span>`:''}</button>`;
}
$('#shBody').addEventListener('click',e=>{
  const sz=e.target.closest('.size');if(sz&&!sz.disabled){S.size=+sz.dataset.v;S.qty=1;document.querySelectorAll('.size').forEach(b=>b.classList.toggle('on',b===sz));const v=S.product.v.find(x=>x.id===S.size);document.querySelector('.info .price').textContent=eur(v.p);renderFoot();return}
  const g=e.target.closest('.gal-nav');if(g){const tr=$('#galTrack');tr.scrollBy({left:tr.clientWidth*+g.dataset.g,behavior:'smooth'});return}
  const th=e.target.closest('[data-ti]');if(th){const tr=$('#galTrack');tr.scrollTo({left:tr.clientWidth*+th.dataset.ti,behavior:'smooth'})}
});
$('#shFoot').addEventListener('click',e=>{
  if(e.target.closest('#qm')){S.qty--;renderFoot()}
  else if(e.target.closest('#qp')){S.qty++;renderFoot()}
  else if(e.target.closest('#addBtn'))addToCart();
});
function addToCart(){
  const p=S.product,v=p.v.find(x=>x.id===S.size);if(!v)return;
  const cur=S.cart.get(v.id);
  const max=maxFor(v);
  const q=Math.min(max,(cur?cur.qty:0)+S.qty);
  cartAdd(v.id,q-(cur?cur.qty:0));
  S.cart.set(v.id,{h:p.h,title:p.t,size:v.s,price:v.p,qty:q,max,img:p.img[0],made:v.q<=0});
  /* immediate feedback on the button, then flight to the order bar */
  const btn=$('#addBtn');if(btn){btn.disabled=true;btn.textContent=t('addedBtn')}
  const msg=t('added')(p.t,v.s);
  const landed=()=>{updateBar();toast(msg)};
  setTimeout(()=>{
    const tr=$('#galTrack'),imgs=tr?[...tr.querySelectorAll('img')]:[];
    const src=imgs[tr?Math.round(tr.scrollLeft/(tr.clientWidth||1)):0]||imgs[0];
    const rect=src?src.getBoundingClientRect():null,url=src?src.currentSrc||src.src:p.img[0];
    closeSheet();
    if(reducedMotion()||!rect||!rect.width||!Element.prototype.animate){landed();return}
    flyToCart(rect,url,landed);
  },600);
}
/* curved flight like the theme's fly-to-cart.js: source center to destination center,
   outer element moves X linearly, inner moves Y on an eased arc and shrinks */
function flyToCart(a,url,done){
  const side=$('#app').classList.contains('cartside')&&innerWidth>=1024;
  const dEl=side?$('#orderbar'):$('#obTotal');
  const b=dEl&&!$('#orderbar').hidden?dEl.getBoundingClientRect():null;
  if(!b||!b.width){done();return}
  const SZ=120;
  const sx=a.left+a.width/2,sy=a.top+a.height/2;
  const dx=b.left+b.width/2,dy=side?b.top+48:b.top+b.height/2;
  const travelX=dx-sx,travelY=dy-sy;
  const outer=document.createElement('div');outer.className='fly-x';
  outer.style.left=(sx-SZ/2)+'px';outer.style.top=(sy-SZ/2)+'px';
  outer.style.setProperty('--travel-x',travelX+'px');outer.style.setProperty('--travel-y',travelY+'px');
  outer.innerHTML=`<div class="fly-y"><img alt="" src="${esc(url)}"></div>`;
  document.body.appendChild(outer);
  const inner=outer.firstElementChild,D=700;
  outer.animate([{transform:'translateX(0)'},{transform:`translateX(${travelX}px)`}],{duration:D,easing:'linear',fill:'forwards'});
  const an=inner.animate([
    {transform:'translateY(0) scale(1)',opacity:1},
    {transform:`translateY(${travelY}px) scale(.35)`,opacity:.6}
  ],{duration:D,easing:'cubic-bezier(.6,-0.3,.8,.6)',fill:'forwards'});
  let fin=false;const end=()=>{if(fin)return;fin=true;outer.remove();done()};
  an.onfinish=end;setTimeout(end,D+250);
}
let toastT;function toast(m){$('#toastT').textContent=m;$('#toast').classList.add('on');clearTimeout(toastT);toastT=setTimeout(()=>$('#toast').classList.remove('on'),2200)}

/* ---------- order bar ---------- */
function updateBar(){
  const n=count();
  $('#obTotal').textContent=eur(sum());
  $('#obCount').textContent=t('pcs')(n);
  const bub=$('#cartBub');bub.textContent=n;bub.classList.toggle('zero',n===0);
  $('#obGo').disabled=n===0;
  $('#sideLines').innerHTML=lines().map(l=>`<div class="sl"><img src="${l.img.replace('width=900','width=120')}" alt=""><div><div style="font-weight:500">${esc(l.title)}</div><div class="hint">${l.size?t('size')+' '+l.size+' · ':''}× ${l.qty}</div></div><span class="num">${eur(l.price*l.qty)}</span></div>`).join('');
  const ob=$('#orderbar');ob.classList.remove('bump');void ob.offsetWidth;if(n)ob.classList.add('bump');
  $('#obMoss').classList.toggle('empty',n===0);
  mossTo('#obMoss',n?Math.min(1,.25+.15*n):0,1600); /* più ordini, più muschio */
}
$('#obGo').onclick=()=>show('order');
$('#cartBtn').onclick=()=>show(count()?'order':'menu');

/* ---------- order screen ---------- */
function renderOrder(){
  const L=lines();
  if(!L.length){$('#orderWrap').innerHTML=`<h2>${t('orderH')}</h2><div class="empty"><p>${t('empty')}</p><button class="btn pri" data-go="menu">${t('toMenu')}</button></div>`;return}
  const anyMade=L.some(l=>l.made);
  if(S.mode==='stand'&&anyMade)S.mode=null;
  $('#orderWrap').innerHTML=`<div style="display:flex;justify-content:space-between;align-items:end;gap:12px;flex-wrap:wrap"><h2>${t('orderH')}</h2><button class="btn" data-go="menu">${t('addMore')}</button></div>
  <div class="lines">${L.map(l=>`<div class="line"><img src="${l.img.replace('width=900','width=200')}" alt=""><div style="min-width:0"><div class="t">${esc(l.title)}</div><div class="s num">${l.size?t('size')+' '+l.size+' · ':''}${eur(l.price)}${l.made?' · '+t('made'):''}</div></div>
    <div class="r">${l.max>1?`<div class="qty"><button data-dq="${l.id}" data-d="-1" aria-label="Meno">−</button><span class="num">${l.qty}</span><button data-dq="${l.id}" data-d="1" ${l.qty>=l.max?'disabled':''} aria-label="Più">+</button></div>`:`<span class="num">× 1</span>`}<button class="rm" data-rm="${l.id}">${t('remove')}</button></div></div>`).join('')}</div>
  <div style="display:grid;gap:12px"><p class="lbl">${t('howGet')}</p><div class="modes">
    ${['ship','pickup','stand'].map(m=>`<button class="mode ${S.mode===m?'on':''}" data-mode="${m}" ${m==='stand'&&anyMade?'disabled':''}><span class="r"></span><span><b>${t('m_'+m)}</b><small>${t('m_'+m+'S')}</small></span></button>`).join('')}
  </div></div>
  <div class="note"><label class="lbl" for="noteIn">${t('note')}</label><textarea id="noteIn" placeholder="${t('notePh')}">${esc(S.note)}</textarea></div>
  <div class="totals num"><div class="big"><span>${t('sub')}</span><span>${eur(sum())}</span></div><div class="hint"><span>${t('shipLater')}</span></div></div>
  <button class="btn pri wide" id="toPay" ${S.mode?'':'disabled'}>${S.mode?t('proceed'):t('chooseMode')}</button>`;
}
$('#orderWrap').addEventListener('click',e=>{
  const go=e.target.closest('[data-go]');if(go){show(go.dataset.go);return}
  const dq=e.target.closest('[data-dq]');if(dq){const id=+dq.dataset.dq,l=S.cart.get(id);if(!l)return;l.qty=Math.min(l.max,l.qty+ +dq.dataset.d);if(l.qty<=0)S.cart.delete(id);cartSet(id,l.qty);updateBar();renderOrder();return}
  const rm=e.target.closest('[data-rm]');if(rm){const id=+rm.dataset.rm;S.cart.delete(id);cartSet(id,0);updateBar();renderOrder();return}
  const md=e.target.closest('[data-mode]');if(md&&!md.disabled){S.mode=md.dataset.mode;renderOrder();return}
  if(e.target.closest('#toPay')){S.code=S.code||makeCode();show('pay')}
});
$('#orderWrap').addEventListener('input',e=>{if(e.target.id==='noteIn')S.note=e.target.value});

/* ---------- pay ---------- */
function makeCode(){const a='23456789ABCDEFGHJKLMNPQRSTUVWXYZ';let s='04-';for(let i=0;i<4;i++)s+=a[Math.floor(Math.random()*a.length)];return s}
function checkoutUrl(){
  const items=lines().map(l=>l.id+':'+l.qty).join(',');
  const q=new URLSearchParams();
  q.set('attributes[kiosk_code]',S.code);
  q.set('attributes[fulfilment]',S.mode==='pickup'?'ritiro-popup':'spedizione');
  q.set('attributes[source]','field-camp-kiosk');
  q.set('attributes[evento]','field-camp');
  if(S.note)q.set('note',S.note);
  if(S.who==='new'){if(S.email)q.set('checkout[email]',S.email);q.set('attributes[newsletter]',S.nl?'si':'no');q.set('attributes[cliente]','nuovo')}
  else if(S.who==='member')q.set('attributes[cliente]','esistente');
  else if(S.who==='guest')q.set('attributes[cliente]','ospite');
  q.set('ref','field-camp-kiosk');
  return STORE+'/cart/'+items+'?'+q.toString();
}
function cartAttrs(){
  const a={kiosk_code:S.code,fulfilment:S.mode==='pickup'?'ritiro-popup':S.mode==='stand'?'stand':'spedizione',source:'field-camp-kiosk',evento:'field-camp'};
  if(S.who==='new'){a.cliente='nuovo';a.newsletter=S.nl?'si':'no'}
  else if(S.who==='member')a.cliente='esistente';
  else if(S.who==='guest')a.cliente='ospite';
  return a;
}
/* rebuild the real cart from local state (covers any failed add/change), then write attributes + note */
function syncCart(){
  const L=lines();
  return cartClear().then(()=>L.length?cartCall('cart/add.js',{items:L.map(l=>({id:l.id,quantity:l.qty}))}):null)
    .then(()=>cartCall('cart/update.js',{attributes:cartAttrs(),note:S.note||''}));
}
function hereUrl(){return ROOT+'checkout'+(S.who==='new'&&S.email?'?checkout[email]='+encodeURIComponent(S.email):'')}
const emailOk=e=>/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e.trim());
function renderPay(){
  const stand=S.mode==='stand';
  const tot=`<div class="totals num"><div class="big"><span>${t('sub')}</span><span>${eur(sum())}</span></div><div class="hint"><span>${t('pcs')(count())} · ${t('m_'+S.mode)}</span></div></div>`;
  if(!stand&&!S.whoOk){
    $('#payWrap').innerHTML=`<div style="display:grid;gap:10px"><h2>${t('whoH')}</h2><p style="font-size:17px;max-width:44ch">${t('whoP')}</p></div>
    <div class="who-grid modes">${['member','new','guest'].map(w=>`<button class="mode ${S.who===w?'on':''}" data-who="${w}"><span class="r"></span><span><b>${t('w_'+w)}</b><small>${t('w_'+w+'S')}</small></span></button>`).join('')}</div>
    ${S.who==='new'?`<div class="email"><label class="lbl" for="emailIn">${t('emailL')}</label><input id="emailIn" type="email" inputmode="email" autocomplete="off" autocapitalize="off" spellcheck="false" value="${esc(S.email)}" placeholder="nome@email.com">
      <p class="err" id="emailErr" hidden>${t('emailErr')}</p>
      <label class="chk"><input type="checkbox" id="nlIn" ${S.nl?'checked':''}><span>${t('nl')}</span></label>
      <p class="hint">${t('accNote')}</p>
      <button class="btn pri wide" id="whoGo">${t('cont')}</button></div>`:''}
    ${tot}
    <div class="cta-row"><button class="btn" data-go="order">← ${t('stOrder')}</button></div>`;
    return;
  }
  const url=checkoutUrl();
  if(!stand)cartCall('cart/update.js',{attributes:cartAttrs(),note:S.note||''}); /* real cart carries the kiosk attributes before payment */
  const staff=S.code+' | '+lines().map(l=>`${l.title}${l.size?' '+l.size:''} x${l.qty} [${l.id}]`).join(' ; ')+' | '+eur(sum());
  $('#payWrap').innerHTML=`<h2>${stand?t('standH'):t('payH2')}</h2>
  ${stand?'':`<div class="who-now"><span class="lbl" style="color:var(--moss-deep)">${t('whoTag')[S.who]}${S.who==='new'&&S.email?' · <span style="text-transform:none;letter-spacing:0">'+esc(S.email)+'</span>':''}</span><button class="rm" data-act="who">${t('change')}</button></div>
  <p style="font-size:17px;max-width:52ch">${t('h_'+S.who)}</p>`}
  <div class="pay">
    <div class="qrbox">${stand?'':`<span class="lbl">${t('payPhone')}</span>`}<div id="qr" role="img" aria-label="QR"></div><span class="lbl" style="color:var(--mute)">${t('code')}</span><span class="code num">${S.code}</span></div>
    <div class="pay-side">
      <p style="font-size:17px;max-width:44ch">${stand?t('standP'):t('payP')}</p>
      ${stand?'':`<ol><li>${t('s1')}</li><li>${t('s2')}</li><li>${t('s3')}</li></ol>`}
      ${tot}
      ${stand?'':`<div class="pay-btns"><a class="btn pri wide" id="payHere" href="${esc(hereUrl())}">${t('payHere')}</a></div>`}
      <div class="cta-row"><button class="btn" data-go="order">← ${t('stOrder')}</button><button class="btn ${stand?'pri':''}" id="paidBtn">${stand?t('standDone'):t('done')}</button></div>
    </div>
  </div>`;
  const box=$('#qr');
  if(window.qrcode){const q=qrcode(0,'M');q.addData(stand?staff:url,'Byte');q.make();box.innerHTML=q.createSvgTag({cellSize:8,margin:2,scalable:true});}
  else box.innerHTML=`<a href="${esc(url)}">${esc(url)}</a>`;
}
function whoContinue(){
  const inp=$('#emailIn');if(inp)S.email=inp.value.trim();
  if(!emailOk(S.email)){$('#emailErr').hidden=false;inp&&inp.focus();return}
  S.whoOk=true;renderPay();$('#s-pay').scrollTop=0;
}
$('#payWrap').addEventListener('click',e=>{
  const go=e.target.closest('[data-go]');if(go){show(go.dataset.go);return}
  const w=e.target.closest('[data-who]');if(w){S.who=w.dataset.who;S.whoOk=S.who!=='new';renderPay();if(S.who==='new'){const i=$('#emailIn');i&&i.focus()}else $('#s-pay').scrollTop=0;return}
  if(e.target.closest('[data-act="who"]')){S.whoOk=false;renderPay();return}
  if(e.target.closest('#whoGo')){whoContinue();return}
  const ph=e.target.closest('#payHere');
  if(ph){e.preventDefault();if(ph.dataset.busy)return;ph.dataset.busy='1';ph.classList.add('busy');
    const go=()=>{location.href=hereUrl()};
    Promise.race([syncCart(),new Promise(r=>setTimeout(r,6000))]).then(go,go);return}
  if(e.target.closest('#paidBtn'))show('thanks');
});
$('#payWrap').addEventListener('input',e=>{
  if(e.target.id==='emailIn'){S.email=e.target.value;const er=$('#emailErr');if(er)er.hidden=true}
  if(e.target.id==='nlIn')S.nl=e.target.checked;
});
$('#payWrap').addEventListener('change',e=>{if(e.target.id==='nlIn')S.nl=e.target.checked});
$('#payWrap').addEventListener('keydown',e=>{if(e.target.id==='emailIn'&&e.key==='Enter'){e.preventDefault();whoContinue()}});

/* ---------- thanks ---------- */
let thT;
function thanks(){
  $('#thP').textContent=S.mode==='stand'?t('thStand')+' '+S.code+'.':t('thP');
  clearTimeout(thT);thT=setTimeout(reset,20000);
}
$('#thDone').onclick=reset;

/* ---------- reset & idle ---------- */
function reset(){
  cartClear();
  S.cart.clear();S.mode=null;S.note='';S.code='';S.product=null;S.who=null;S.whoOk=false;S.email='';S.nl=false;
  closeSheet();$('#idle').hidden=true;clearTimeout(thT);
  if(lang!=='it'){lang='it';applyLang()}else{updateBar();renderMenu()}
  show('attract');
}
$('#restartBtn').onclick=reset;
$('#backBtn').onclick=()=>{if($('#sheet').classList.contains('open')){closeSheet();return}if(S.screen==='pay'&&S.who&&S.mode!=='stand'){S.who=null;S.whoOk=false;renderPay();return}const to=BACK[S.screen];if(to==='attract')reset();else if(to)show(to)};
let last=Date.now(),idleOn=false,idleLeft=20;
['pointerdown','keydown','scroll','touchstart'].forEach(ev=>document.addEventListener(ev,()=>{last=Date.now();if(idleOn&&ev!=='scroll'){}},{passive:true,capture:true}));
setInterval(()=>{
  if(['attract','thanks'].includes(S.screen)){idleOn=false;$('#idle').hidden=true;return}
  const limit=S.screen==='pay'?90000:60000;
  if(!idleOn&&Date.now()-last>limit){idleOn=true;idleLeft=20;$('#idle').hidden=false}
  if(idleOn){
    $('#idleN').textContent=idleLeft;$('#ringArc').style.strokeDashoffset=276.5*(1-idleLeft/20);
    if(idleLeft--<=0){idleOn=false;reset()}
  }
},1000);
$('#idleStay').onclick=()=>{idleOn=false;last=Date.now();$('#idle').hidden=true};
$('#idleReset').onclick=reset;

/* ---------- entry ---------- */
const goFull=()=>{if(KIOSK&&document.documentElement.requestFullscreen)document.documentElement.requestFullscreen().catch(()=>{})};
$('#s-attract').addEventListener('click',e=>{goFull();show(e.target.closest('#attHow')?'story':'menu')});
$('#startOrder').onclick=()=>show('menu');
$('#langs').addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;e.stopPropagation();lang=b.dataset.l;applyLang()});
if(KIOSK){document.addEventListener('contextmenu',e=>e.preventDefault());if(navigator.wakeLock)navigator.wakeLock.request('screen').catch(()=>{})}
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&$('#sheet').classList.contains('open'))closeSheet()});

cartClear(); /* start clean: the kiosk never inherits a previous session's cart */
renderMenu();updateBar();applyLang();show('attract');
})();

